export default {
    namespaced: true,

    state: {
        statusFilter: 'all',
        typeFilter: 'all',
        searchTypeFilter: {
            text: '',
            type: 'search'
        },
        identifierFilter: '',
        idSearchFilter: '',
        sortFilter: 'desc',
        userFilter: null,
        perPageFilter: 10,
        expireTypeFilter: {
            expired_type: '',
            days: null
        },
        hasError: false,
        createQrID: null,
        qrType: null
    },

    getters: {
        hasFilter: (state) => !!(state.statusFilter !== 'all'
            || state.typeFilter !== 'all'
            || state.searchTypeFilter.text || state.searchTypeFilter?.text?.length >= 3
            || state.sortFilter !== 'desc'
            || state.userFilter
            || state.expireTypeFilter.days
            || state.identifierFilter
            || state.idSearchFilter
            || state.perPageFilter != 10),
        statusFilter: (state) => state.statusFilter,
        typeFilter: (state) => state.typeFilter,
        searchTypeFilter: (state) => state.searchTypeFilter,
        identifierFilter: (state) => state.identifierFilter,
        idSearchFilter: (state) => state.idSearchFilter,
        sortFilter: (state) => state.sortFilter,
        userFilter: (state) => state.userFilter,
        expireTypeFilter: (state) => state.expireTypeFilter,
        perPageFilter: (state) => state.perPageFilter,
        createQrID: state => state.createQrID
    },

    mutations: {
        updateStatus(state, input) {
            state.statusFilter = input
        },
        updateType(state, input) {
            state.typeFilter = input
        },
        updateSearch(state, input) {
            state.searchTypeFilter = input
        },
        updateIdentifier(state, input) {
            state.identifierFilter = input
        },
        updateIdSearch(state, input) {
            state.idSearchFilter = input
        },
        updateSort(state, input) {
            state.sortFilter = input
        },
        updateUser(state, input) {
            state.userFilter = input
        },
        updateExpireType(state, input) {
            state.expireTypeFilter = input
        },
        updatePerPage(state, input) {
            state.perPageFilter = input
        },
        reset(state) {
            state.statusFilter = 'all'
            state.typeFilter = 'all'
            state.searchTypeFilter = {
                text: '',
                type: 'search',
            }
            state.sortFilter = 'desc'
            state.userFilter = null
            state.perPageFilter = '10'
            state.identifierFilter = ''
            state.idSearchFilter = ''
        },
        updateHasError(state, input) {
            state.hasError = input
        },
        set_created_qrID(state, input) {
            state.createQrID = input
        },
        set_qr_type(state, input) {
            state.qrType = input
        }
    },

    actions: {
        updateStatusFilter({commit}, input) {
            commit('updateStatus', input)
        },
        updateTypeFilter({commit}, input) {
            commit('updateType', input)
        },
        updateSearchTypeFilter({commit}, input) {
            commit('updateSearch', input)
        },
        updateIdentifierFilter({commit}, input) {
            commit('updateIdentifier', input)
        },
        updateIdSearchFilter({commit}, input) {
            commit('updateIdSearch', input)
        },
        updateSortFilter({commit}, input) {
            commit('updateSort', input)
        },
        updateUserFilter({commit}, input) {
            commit('updateUser', input)
        },
        updateExpireTypeFilter({commit}, input) {
            commit('updateExpireType', input)
        },
        updatePerPageFilter({commit}, input) {
            commit('updatePerPage', input)
        },
        resetStates({commit}) {
            commit('reset')
        },
        updateHasError({commit}, input) {
            commit('updateHasError', input)
        },
        setCreatedQrID({commit}, input) {
            commit('set_created_qrID', input)
        },
        setQrType({commit}, input) {
            commit('set_qr_type', input)
        }
    }
}